import { useState } from 'react';
import { IconSignOut, IconUserFilled, Menu, Text, UserBarItem, VStack } from '@direct-frontend/components';
import { getSafeUserRequestContext } from '#shared/lib/context';
import { emailAuthRoute } from '#shared/lib/routes';
import { showError } from '#shared/lib/toast';
import { logoutEmail } from '../api/emailAuthApi';
import styles from './EmailAuthUserBarItem.module.css';

export const EmailAuthUserBarItem = ({ className }: { className?: string }) => {
    const [isLoggingOut, setIsLoggingOut] = useState(false);
    const { email } = getSafeUserRequestContext();

    const handleLogout = async () => {
        if (isLoggingOut) {
            return;
        }

        setIsLoggingOut(true);

        try {
            await logoutEmail();
            window.location.replace(emailAuthRoute.route);
        } catch (error) {
            setIsLoggingOut(false);
            showError({ label: 'Не удалось выйти из кабинета' }, error);
        }
    };

    return (
        <Menu
            items={[
                {
                    value: 'logout',
                    content: isLoggingOut ? 'Выходим…' : 'Выйти',
                    disabled: isLoggingOut,
                    iconLeft: <IconSignOut size="24" />,
                    onAction: handleLogout,
                },
            ]}
            addonBefore={
                <VStack className={styles.userInfo} gap="4">
                    <Text size="s" role="supplementary">
                        Вы вошли как
                    </Text>
                    <Text className={styles.email} size="m" bold isTruncated title={email}>
                        {email}
                    </Text>
                </VStack>
            }
            data-testid="EmailAuthUserBarItem.Menu"
            placement="left-start"
            size="m"
            width={280}
            trigger={
                <UserBarItem className={className} icon={IconUserFilled} data-testid="EmailAuthUserBarItem.Button" />
            }
        />
    );
};
